// extracted by mini-css-extract-plugin
export var container = "layout-module--container--YM7Lx";
export var footer = "layout-module--footer--3iD_9";